export const mapColumnContent = (content) => {
  return content.reduce((accum, current) => {
    const currentModified = Object.getOwnPropertyNames(current).map((item) => ({
      key: item,
      value: current[item],
    }));
    return [...accum, currentModified];
  }, []);
};
